// import { useState } from "react";
// import "./Footer.css";
// import {
//   IconCircles,
//   IconHome,
//   IconSettings2,
//   IconUser,
//   IconUsers,
// } from "@tabler/icons-react";

// export default function Footer() {
//   const [active, setActive] = useState("home"); // Default active item
//   return (
//     <>
//       <div className="d-block d-md-block d-lg-none">
//         <div className="fixed_footer">
//           <a
//             href="/aspettoportal_dev/frontend/contract-type"
//             className={active === "settings" ? "active" : ""}
//             onClick={() => setActive("settings")}
//           >
//             <IconSettings2 stroke={1.5} /> <span>Setting</span>
//           </a>
//           <a
//             href="#"
//             className={active === "profile" ? "active" : ""}
//             onClick={() => setActive("profile")}
//           >
//             <IconUser stroke={1.5} /> <span>Profile</span>
//           </a>
//           <a
//             href="#"
//             className={active === "home" ? "active" : ""}
//             onClick={() => setActive("home")}
//           >
//             <IconHome stroke={1.5} /> <span>Home</span>
//           </a>
//           <a
//             href="/aspettoportal_dev/frontend/users"
//             className={active === "users" ? "active" : ""}
//             onClick={() => setActive("users")}
//           >
//             <IconUsers stroke={1.5} /> <span>Users</span>
//           </a>
//           <a
//             href="/aspettoportal_dev/frontend/roles"
//             className={active === "roles" ? "active" : ""}
//             onClick={() => setActive("roles")}
//           >
//             <IconCircles stroke={1.5} /> <span>Roles</span>
//           </a>
//         </div>
//       </div>
//     </>
//   );
// }

import { useState } from "react";
import { NavLink } from "react-router-dom"; 
import "./Footer.css";
import {
  IconCircles,
  IconHome,
  IconSettings2,
  IconUser,
  IconUsers,
} from "@tabler/icons-react";

export default function Footer() {
  const [active, setActive] = useState("home"); 

  return (
    <>
      <div className="d-block d-md-block d-lg-none">
        <div className="fixed_footer">
          <NavLink
            to="/contract-type"
            className={active === "settings" ? "active" : ""}
            onClick={() => setActive("settings")}
          >
            <IconSettings2 stroke={1.5} /> <span>Setting</span>
          </NavLink>
          
          <NavLink
            to="/" 
            className={active === "profile" ? "active" : ""}
            onClick={() => setActive("profile")}
          >
            <IconUser stroke={1.5} /> <span>Profile</span>
          </NavLink>

          {/* <NavLink
            to="/dashboard"
            className={active === "home" ? "active" : ""}
            onClick={() => setActive("home")}
          >
            <IconHome stroke={1.5} /> <span>Home</span>
          </NavLink> */}

          <NavLink
            to="/users" 
            className={active === "users" ? "active" : ""}
            onClick={() => setActive("users")}
          >
            <IconUsers stroke={1.5} /> <span>Users</span>
          </NavLink>

          <NavLink
            to="/departments"
            className={active === "roles" ? "active" : ""}
            onClick={() => setActive("roles")}
          >
            <IconCircles stroke={1.5} /> <span>Departments</span>
          </NavLink>
        </div>
      </div>
    </>
  );
}
